import { QUERY_GET_PROVINCES} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getProvinces = baseThunk(`provinces/getProvinces`, QUERY_GET_PROVINCES, "GET")
